/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Laptop: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="laptop" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1303.3333333333333 340V226.6666666666668H56.6666666666667V340H1303.3333333333333zM1076.6666666666665 1190C1107.8333333333333 1190 1134.4666666666667 1178.8933333333334 1156.6799999999998 1156.68C1178.8933333333332 1134.4666666666667 1190 1107.8333333333333 1190 1076.6666666666667V453.3333333333334H170V1076.6666666666667C170 1107.8333333333333 181.1066666666667 1134.4666666666667 203.32 1156.68A109.0833333333333 109.0833333333333 0 0 0 283.3333333333333 1190H1076.6666666666665zM283.3333333333333 566.6666666666667H1076.6666666666665V1076.6666666666667H283.3333333333333V566.6666666666667z" : "M1042.6666666666667 272V181.3333333333333H45.3333333333333V272H1042.6666666666667zM861.3333333333334 952C886.2666666666668 952 907.5733333333334 943.1146666666666 925.344 925.344C943.1146666666666 907.5733333333332 952 886.2666666666667 952 861.3333333333333V362.6666666666667H136V861.3333333333333C136 886.2666666666667 144.8853333333333 907.5733333333332 162.656 925.344A87.2666666666667 87.2666666666667 0 0 0 226.6666666666667 952H861.3333333333334zM226.6666666666667 453.3333333333333H861.3333333333334V861.3333333333333H226.6666666666667V453.3333333333333z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Laptop.displayName = `Blueprint5.Icon.Laptop`;
export default Laptop;
